// src/components/LoadingOverlay/GlobalLoading.jsx
import { useLoading } from './LoadingContext';
import LoadingOverlay from './LoadingOverlay';

const GlobalLoading = () => {
  const { loading } = useLoading();

  return (
    <LoadingOverlay
      visible={loading.visible}
      message={loading.message}
    />
  );
};

export default GlobalLoading;
